import anacortesYachtClubFlag from '../assets/Yacht_Club_Flags/1-AnacortesYachtClub-burgee_sm_10.png';
import bellevueYachtClubFlag from '../assets/Yacht_Club_Flags/2-bellevue.gif';
import bellinghamYachtClubFlag from '../assets/Yacht_Club_Flags/3-bellingham.gif';
import birchBayVillageYachtClubFlag from '../assets/Yacht_Club_Flags/4-birchbayyc.gif';
import bremertonYachtClubFlag from '../assets/Yacht_Club_Flags/5-bremertonyc.gif';
import brownsvilleYachtClubFlag from '../assets/Yacht_Club_Flags/6-brownsvilleyc.gif';
import camanoIslandYachtClubFlag from '../assets/Yacht_Club_Flags/7-camanoislyc.gif';
import carlingYachtClubFlag from '../assets/Yacht_Club_Flags/8-CarlingYCGif.gif';
import corinthianYachtClubOfBellinghamFlag from '../assets/Yacht_Club_Flags/9-cycbellinghamgif.gif';
import corinthianYachtClubOfEdmondsFlag from '../assets/Yacht_Club_Flags/10-CYCEdmondsGif.gif';
import corinthianYachtClubOfSeattleFlag from '../assets/Yacht_Club_Flags/11-CYCSeattleGif.gif';
import corinthianYachtClubOfTacomaFlag from '../assets/Yacht_Club_Flags/12-CYCTacomaYCGif.gif';
import dagmarsYachtClubFlag from '../assets/Yacht_Club_Flags/13-DagmarsYCGif.gif';
import dayIslandYachtClubFlag from '../assets/Yacht_Club_Flags/14-DayIslandYCGif.gif';
import deerHarborYachtClubFlag from '../assets/Yacht_Club_Flags/15-dearharboryachtclub_616.png';
import desMoinesYachtClubFlag from '../assets/Yacht_Club_Flags/16-desmoinesyc.gif';
import duwamishYachtClubFlag from '../assets/Yacht_Club_Flags/17-DuwamishYCGif.gif';
import eagleHarborYachtClubFlag from '../assets/Yacht_Club_Flags/18-EagleHarborGif.gif';
import edmondsYachtClubFlag from '../assets/Yacht_Club_Flags/19-EdmondsYCGif.gif';
import emeraldRoseYachtClubFlag from '../assets/Yacht_Club_Flags/20-emeraldroseycsolidrose_21.png';
import everettYachtClubFlag from '../assets/Yacht_Club_Flags/21-EverettYC_burgeesiteimage__30.png';
import fidalgoYachtClubFlag from '../assets/Yacht_Club_Flags/22-FidalgoGif.gif';
import fircrestYachtClubFlag from '../assets/Yacht_Club_Flags/23-FirecrestYC_burgee_01_83.png';
import flounderBayYachtClubFlag from '../assets/Yacht_Club_Flags/24-FlounderBayYCGif.gif';
import foxIslandYachtClubFlag from '../assets/Yacht_Club_Flags/25-FoxIslandYC_new burgree2.jpg';
import gigHarborYachtClubFlag from '../assets/Yacht_Club_Flags/26-GifHarborYCGif.gif';
import hatIslandYachtGolfClubFlag from '../assets/Yacht_Club_Flags/27-HatIslandYCGif.gif';
import hiddenHarborYachtClubFlag from '../assets/Yacht_Club_Flags/28-HiddenHarborYCGif.gif';
import kingstonCoveYachtClubFlag from '../assets/Yacht_Club_Flags/29-KingstonCoveGif.gif';
import laConnerYachtClubFlag from '../assets/Yacht_Club_Flags/30-LaConnerYC-WA.png';
import lopezIslandYachtClubFlag from '../assets/Yacht_Club_Flags/31-lopezislandyc.gif';
import meydenbauerBayYachtClubFlag from '../assets/Yacht_Club_Flags/32-MeydenbaurBayYCGif.gif';
import milltownSailingAssociationFlag from '../assets/Yacht_Club_Flags/33-MilltowSailingAssn_msalogo22__33__33.gif';
import mukilteoYachtClubFlag from '../assets/Yacht_Club_Flags/34-MukilteoYachtClub_burgeesm__31.gif';
import navyYachtClubEverettFlag from '../assets/Yacht_Club_Flags/35-NavyYachtClub-Everett-eburgee__32.gif';
import oakHarborYachtClubFlag from '../assets/Yacht_Club_Flags/36-OakHarborGif.gif';
import olympiaYachtClubFlag from '../assets/Yacht_Club_Flags/37-OlympiaYCGif.gif';
import orcasIslandYachtClubFlag from '../assets/Yacht_Club_Flags/38-orcasislandyc.gif';
import oroBayYachtClubFlag from '../assets/Yacht_Club_Flags/39-OroBayYCGif.gif';
import pleasantHarborYachtClubFlag from '../assets/Yacht_Club_Flags/40-PleasantHarborYachtClub_phycburgee__39.png';
import pointRobertsMarinaResortFlag from '../assets/Yacht_Club_Flags/41-PointRobertsMarinaResort_burgee__20.png';
import pointRobertsYachtClubFlag from '../assets/Yacht_Club_Flags/42-PointRobertsYC_burgee__19.png';
import portAngelesYachtClubFlag from '../assets/Yacht_Club_Flags/43-PortAngelesYC_Gif.gif';
import portLudlowYachtClubFlag from '../assets/Yacht_Club_Flags/44-portludlow.gif';
import portMadisonYachtClubFlag from '../assets/Yacht_Club_Flags/45-PortMadisonYCGif.gif';
import portOrchardYachtClubFlag from '../assets/Yacht_Club_Flags/46-PortOrchardYachtClub_burgee__52.gif';
import portTownsendYachtClubFlag from '../assets/Yacht_Club_Flags/47-PortTownsendGif.gif';
import poulsboYachtClubFlag from '../assets/Yacht_Club_Flags/48-PoulsboYCGif.gif';
import pugetSoundYachtClubFlag from '../assets/Yacht_Club_Flags/49-PugetSoundYC_Gif.gif';
import quartermasterYachtClubFlag from '../assets/Yacht_Club_Flags/50-QuartermasterYCGif.gif';
import queenCityYachtClubFlag from '../assets/Yacht_Club_Flags/51-QueenCityGif.gif';
import rainierYachtClubFlag from '../assets/Yacht_Club_Flags/52-RanierGif.gif';
import rocheHarborYachtClubFlag from '../assets/Yacht_Club_Flags/53-RocheHarborGif.gif';
import sanJuanIslandYachtClubFlag from '../assets/Yacht_Club_Flags/54-SanJuanIslandYachtClub.gif';
import seabacsYachtClubBoeingCoFlag from '../assets/Yacht_Club_Flags/55-SeabacsGif.gif';
import seattleSinglesYachtClubFlag from '../assets/Yacht_Club_Flags/56-SeattleSinglesGif.gif';
import seattleYachtClubFlag from '../assets/Yacht_Club_Flags/57-SeattleYCGif.gif';
import semiahmooMarinaYachtClubFlag from '../assets/Yacht_Club_Flags/58-SemiahmooYachtClubMarina.jpg';
import semiahmooYachtClubFlag from '../assets/Yacht_Club_Flags/59-SemiahmooYCGif.gif';
import sequimBayYachtClubFlag from '../assets/Yacht_Club_Flags/60-SequimGif.gif';
import shelterBayYachtClubFlag from '../assets/Yacht_Club_Flags/61-ShelterBayYC_burgee.jpg';
import sheltonYachtClubFlag from '../assets/Yacht_Club_Flags/62-SheltonYCGif.gif';
import shilsholeBayYachtClubFlag from '../assets/Yacht_Club_Flags/63-ShilsholeGif.gif';
import sinclairInletYachtClubFlag from '../assets/Yacht_Club_Flags/64-sinclairinletycnew.gif';
import sloopTavernYachtClubFlag from '../assets/Yacht_Club_Flags/65-slooptavern.gif';
import southSoundSailingSocietyFlag from '../assets/Yacht_Club_Flags/66-SouthSoundSS.gif';
import southWhidbeyYachtClubFlag from '../assets/Yacht_Club_Flags/67-SouthWhidbeyYachtClub_2697.jpg';
import squalicumYachtClubFlag from '../assets/Yacht_Club_Flags/68-squalicumyc.gif';
import swinomishYachtClubFlag from '../assets/Yacht_Club_Flags/69-SwinomishGif.gif';
import tacomaYachtClubFlag from '../assets/Yacht_Club_Flags/70-tacoma-yacht-club-burgee-only-web__84.png';
import threeTreePointYachtClubFlag from '../assets/Yacht_Club_Flags/71-ThreeTreePointYachtClub_flag__75.png';
import totemYachtClubFlag from '../assets/Yacht_Club_Flags/72-totemyc.gif';
import tyeeYachtClubSeattleFlag from '../assets/Yacht_Club_Flags/73-TyeeYCSeattleGif.gif';
import vikingYachtClubFlag from '../assets/Yacht_Club_Flags/74-vikingyc.gif';
import washingtonYachtClubFlag from '../assets/Yacht_Club_Flags/75-WashingtonYCGif.gif';
import westSeattleYachtClubFlag from '../assets/Yacht_Club_Flags/76-WSeattleYCGif.gif';
import westSoundCorinthianYachtClubFlag from '../assets/Yacht_Club_Flags/77-WSoundCYCGif.gif';
import yakimaValleyBoatClubFlag from '../assets/Yacht_Club_Flags/78-yakimavalleybc.gif';
import defaultYachtClubFlag from '../assets/Yacht_Club_Flags/default-yacht-club-flag.svg';
import anacortesYachtChartersLogo from '../assets/Charter_Company_Logos/AnacortesYachtCharters-logo-800x800.png';
import freedomBoatClubSeattleLogo from '../assets/Charter_Company_Logos/FreedomBoatClub-logo.png';
import sanJuanSailingYachtingLogo from '../assets/Charter_Company_Logos/SanJuanSailingYachtig-logo-300x300.png';
import seattleSailingClubLogo from '../assets/Charter_Company_Logos/SeattleSailingClub-logo-800x800.png';

export const CHARTER_COMPANY_LOGO_URL_BY_KEY = {
  'anacortes yacht charters': anacortesYachtChartersLogo,
  'freedom boat club seattle': freedomBoatClubSeattleLogo,
  'san juan sailing & yachting': sanJuanSailingYachtingLogo,
  'seattle sailing club': seattleSailingClubLogo,
};

export const DEFAULT_YACHT_CLUB_FLAG_URL = defaultYachtClubFlag;

export const YACHT_CLUB_FLAG_URL_BY_KEY = {
  'anacortes yacht club': anacortesYachtClubFlag,
  'bellevue yacht club': bellevueYachtClubFlag,
  'bellingham yacht club': bellinghamYachtClubFlag,
  'birch bay village yacht club': birchBayVillageYachtClubFlag,
  'bremerton yacht club': bremertonYachtClubFlag,
  'brownsville yacht club': brownsvilleYachtClubFlag,
  'camano island yacht club': camanoIslandYachtClubFlag,
  'carling yacht club': carlingYachtClubFlag,
  'corinthian yacht club of bellingham': corinthianYachtClubOfBellinghamFlag,
  'corinthian yacht club of edmonds': corinthianYachtClubOfEdmondsFlag,
  'corinthian yacht club of seattle': corinthianYachtClubOfSeattleFlag,
  'corinthian yacht club of tacoma': corinthianYachtClubOfTacomaFlag,
  'dagmars yacht club': dagmarsYachtClubFlag,
  'day island yacht club': dayIslandYachtClubFlag,
  'deer harbor yacht club': deerHarborYachtClubFlag,
  'des moines yacht club': desMoinesYachtClubFlag,
  'duwamish yacht club': duwamishYachtClubFlag,
  'eagle harbor yacht club': eagleHarborYachtClubFlag,
  'edmonds yacht club': edmondsYachtClubFlag,
  'emerald rose yacht club': emeraldRoseYachtClubFlag,
  'everett yacht club': everettYachtClubFlag,
  'fidalgo yacht club': fidalgoYachtClubFlag,
  'fircrest yacht club': fircrestYachtClubFlag,
  'flounder bay yacht club': flounderBayYachtClubFlag,
  'fox island yacht club': foxIslandYachtClubFlag,
  'gig harbor yacht club': gigHarborYachtClubFlag,
  'hat island yacht & golf club': hatIslandYachtGolfClubFlag,
  'hidden harbor yacht club': hiddenHarborYachtClubFlag,
  'kingston cove yacht club': kingstonCoveYachtClubFlag,
  'la conner yacht club': laConnerYachtClubFlag,
  'lopez island yacht club': lopezIslandYachtClubFlag,
  'meydenbauer bay yacht club': meydenbauerBayYachtClubFlag,
  'milltown sailing association': milltownSailingAssociationFlag,
  'mukilteo yacht club': mukilteoYachtClubFlag,
  'navy yacht club - everett': navyYachtClubEverettFlag,
  'oak harbor yacht club': oakHarborYachtClubFlag,
  'olympia yacht club': olympiaYachtClubFlag,
  'orcas island yacht club': orcasIslandYachtClubFlag,
  'oro bay yacht club': oroBayYachtClubFlag,
  'pleasant harbor yacht club': pleasantHarborYachtClubFlag,
  'point roberts marina resort': pointRobertsMarinaResortFlag,
  'point roberts yacht club': pointRobertsYachtClubFlag,
  'port angeles yacht club': portAngelesYachtClubFlag,
  'port ludlow yacht club': portLudlowYachtClubFlag,
  'port madison yacht club': portMadisonYachtClubFlag,
  'port orchard yacht club': portOrchardYachtClubFlag,
  'port townsend yacht club': portTownsendYachtClubFlag,
  'poulsbo yacht club': poulsboYachtClubFlag,
  'puget sound yacht club': pugetSoundYachtClubFlag,
  'quartermaster yacht club': quartermasterYachtClubFlag,
  'queen city yacht club': queenCityYachtClubFlag,
  'rainier yacht club': rainierYachtClubFlag,
  'roche harbor yacht club': rocheHarborYachtClubFlag,
  'san juan island yacht club': sanJuanIslandYachtClubFlag,
  'seabacs yacht club (boeing co.)': seabacsYachtClubBoeingCoFlag,
  'seattle singles yacht club': seattleSinglesYachtClubFlag,
  'seattle yacht club': seattleYachtClubFlag,
  'semiahmoo marina yacht club': semiahmooMarinaYachtClubFlag,
  'semiahmoo yacht club': semiahmooYachtClubFlag,
  'sequim bay yacht club': sequimBayYachtClubFlag,
  'shelter bay yacht club': shelterBayYachtClubFlag,
  'shelton yacht club': sheltonYachtClubFlag,
  'shilshole bay yacht club': shilsholeBayYachtClubFlag,
  'sinclair inlet yacht club': sinclairInletYachtClubFlag,
  'sloop tavern yacht club': sloopTavernYachtClubFlag,
  'south sound sailing society': southSoundSailingSocietyFlag,
  'south whidbey yacht club': southWhidbeyYachtClubFlag,
  'squalicum yacht club': squalicumYachtClubFlag,
  'swinomish yacht club': swinomishYachtClubFlag,
  'tacoma yacht club': tacomaYachtClubFlag,
  'three tree point yacht club': threeTreePointYachtClubFlag,
  'totem yacht club': totemYachtClubFlag,
  'tyee yacht club - seattle': tyeeYachtClubSeattleFlag,
  'viking yacht club': vikingYachtClubFlag,
  'washington yacht club': washingtonYachtClubFlag,
  'west seattle yacht club': westSeattleYachtClubFlag,
  'west sound corinthian yacht club': westSoundCorinthianYachtClubFlag,
  'yakima valley boat club': yakimaValleyBoatClubFlag,
};
